import React from "react";
import routes from "../routes";
import { convertRouteToRouteur, generateChildren } from "./RouterGenerator";

let children = generateChildren([
  routes.root().main,
  routes.interpretes().list,
  routes.prestations().list,
  routes.institutions().list,
  routes.institutions().merge,
  routes.institutions().mergeHistory,
  routes.institutions().mergeDetail(),
  routes.principals().list,
  routes.logs().detail,
  routes.logs().list,
  routes.billing().list,
  routes.users().list,
]);

const index = convertRouteToRouteur(routes.root().index);
index.children = children;

export const routerMainLayout = index;
